import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  pageWrapper: {
    paddingTop: '32px'
  }
});
export default useStyles;